var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk2474430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.1 30",
    style: {
      enableBackground: "new 0 0 115.1 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: -6.2,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 0.1743 15.9913)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.8762 9.6308)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,30H0V0.4h29.8V30z M1.1,28.9h27.5V1.5H1.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26H3.9V4h22.5V26z M5,24.8h20.2V5.2H5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 1.5625 21.9524)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.9,
    y: 7.4,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 3.7392 49.3655)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,30H28.3V0.4h29.8V30z M29.5,28.9H57V1.5H29.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2,26H31.7V4h22.5V26z M32.9,24.8h20.2V5.2H32.9V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.6,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.2615 48.755)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.9,
    y: 7.4,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 32.3536 98.7762)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1,30H85.3V0.4h29.8V30z M86.5,28.9h27.5V1.5H86.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2,26H88.7V4h22.5V26z M89.8,24.8H110V5.2H89.8V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.3,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 4.9287 35.4207)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 7.4,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 18.1152 74.1896)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,30H57V0.4h29.8V30z M58.1,28.9h27.5V1.5H58.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8,26H60.4V4h22.5V26z M61.5,24.8h20.2V5.2H61.5V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7,29.6c-0.2,0-0.4-0.1-0.5-0.3l-1.5-3.2c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.5,3.2c0.1,0.3,0,0.6-0.3,0.8 L28.7,29.6z M26,24c-0.2,0-0.4-0.1-0.5-0.3l-1.5-3.2c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.5,3.2c0.1,0.3,0,0.6-0.3,0.8 L26,24z M23.3,18.5c-0.2,0-0.4-0.1-0.5-0.3L21.3,15c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.5,3.2c0.1,0.3,0,0.6-0.3,0.8 L23.3,18.5z M20.6,12.9c-0.2,0-0.4-0.1-0.5-0.3l-1.5-3.2c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.5,3.2 c0.1,0.3,0,0.6-0.3,0.8L20.6,12.9z M18,7.3c-0.2,0-0.4-0.1-0.5-0.3l-1.5-3.2c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.5,3.2 c0.1,0.3,0,0.6-0.3,0.8L18,7.3z M15.3,1.7c-0.2,0-0.4-0.1-0.5-0.3l-0.3-0.6c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l0.3,0.6 c0.1,0.3,0,0.6-0.3,0.8L15.3,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3,29.6l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l1.5-3.2c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-1.5,3.2 C1.7,29.5,1.5,29.6,1.3,29.6z M4,24L3.8,24c-0.3-0.1-0.4-0.5-0.3-0.8L5,20c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8 l-1.5,3.2C4.4,23.9,4.2,24,4,24z M6.7,18.5l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l1.5-3.2c0.1-0.3,0.5-0.4,0.8-0.3 c0.3,0.1,0.4,0.5,0.3,0.8l-1.5,3.2C7.1,18.3,6.9,18.5,6.7,18.5z M9.4,12.9l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l1.5-3.2 c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-1.5,3.2C9.8,12.8,9.6,12.9,9.4,12.9z M12,7.3l-0.2-0.1 c-0.3-0.1-0.4-0.5-0.3-0.8L13,3.3C13.2,3,13.5,2.9,13.8,3c0.3,0.1,0.4,0.5,0.3,0.8L12.5,7C12.4,7.2,12.2,7.3,12,7.3z M14.7,1.7 l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l0.3-0.6C14.6,0,15-0.1,15.2,0.1c0.3,0.1,0.4,0.5,0.3,0.8l-0.3,0.6C15.1,1.6,14.9,1.7,14.7,1.7z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk2474430);
export default __webpack_public_path__ + "static/media/AK2_4_7443_0.3f21e868eb2a6c7a961c20e5c3bb21d9.svg";
export { ForwardRef as ReactComponent };